<template>
  <div class="login">
    <Row v-if="loginModalType!='register'" class="login-header" justify="space-around">
      <i-col span="5">{{ type }}</i-col>
      <i-col span="17" class="change">
        <div @click="toggleType">
          <span style>{{ type=='扫码登录' ? '密码登陆' : '扫码登录'}}</span>
          <i
            :class="[type == '扫码登录' ? 'fa fa-user' : 'fa fa-qrcode']"
            style="font-size:30px;margin-left: 10px;"
          ></i>
          <!-- <i class="border" v-show="type"></i> -->
          <!-- <svg-icon icon-class="ewm" v-show="!type" style="font-size: 20px"></svg-icon> -->
        </div>
      </i-col>
    </Row>

    <!-- 扫码登录 -->
    <div class="tip" v-show="type=='扫码登录'">
      <div id="qrcode">
        <!-- <img src="../../assets/common/logo.png" alt /> -->
      </div>
      <svg-icon class="svg" icon-class="wx1"></svg-icon>
      <span>打开 微信 扫一扫完成登录</span>
    </div>
    <div class="footer" v-show="type=='扫码登录'">
      <!-- <a href="javascript:void()">下载APP</a> -->
      <a @click="register">免费注册</a>
    </div>

    <!-- 密码登录 -->
    <Form
      v-show="type=='密码登录'"
      ref="formInline"
      :model="formInline"
      :rules="ruleInline"
      class="login-form"
    >
      <form-item prop="username">
        <i-input
          style="height: 45px"
          type="text"
          v-model="formInline.username"
          placeholder="用户名/手机号"
        >
          <Icon type="ios-person-outline" slot="prepend"></Icon>
        </i-input>
      </form-item>
      <form-item prop="password">
        <i-input
          style="height: 45px"
          type="password"
          v-model="formInline.password"
          placeholder="请输入登录密码"
        >
          <Icon type="ios-lock-outline" slot="prepend"></Icon>
        </i-input>
      </form-item>
      <form-item>
        <a
          href="javascript: void(0)"
          class="submit"
          type="primary"
          @click="handleSubmit('formInline')"
        >登录</a>
      </form-item>
    </Form>
    <!-- 找回用户名 -->
    <Form
      v-show="type=='忘记用户名'"
      ref="findUsernameFrom"
      :model="findUsernameFrom"
      :rules="findUsernameRule"
      class="login-form"
    >
      <form-item prop="phone">
        <i-input
          style="height: 45px"
          type="text"
          v-model="findUsernameFrom.phone"
          placeholder="手机号"
        ></i-input>
      </form-item>
      <FormItem label="验证码：">
        <Row type="flex">
          <i-col span="14">
            <j-graphic-code @success="generateCode" />
          </i-col>
          <i-col span="10">
            <i-input maxlength="4" v-model="findUsernameFrom.graphicCode" placeholder="请输入图形验证码"></i-input>
          </i-col>
        </Row>
      </FormItem>
      <form-item>
        <a
          href="javascript: void(0)"
          class="submit"
          type="primary"
          @click="handleFindUsername('findUsernameFrom')"
        >找回</a>
      </form-item>
    </Form>

    <!-- 找回密码 -->
    <Alteration v-show="type=='忘记密码'" />
    <!-- <Form
      v-show="type=='忘记密码1'"
      ref="findUsernameFrom"
      :model="findUsernameFrom"
      :rules="findUsernameRule"
      class="login-form"
    >
      <form-item prop="phone">
        <i-input
          style="height: 45px"
          type="text"
          v-model="findUsernameFrom.phone"
          placeholder="手机号"
        ></i-input>
      </form-item>
      <FormItem label="验证码：">
        <Row type="flex">
          <i-col span="14">
            <j-graphic-code @success="generateCode" />
          </i-col>
          <i-col span="10">
            <i-input maxlength="4" v-model="findUsernameFrom.graphicCode" placeholder="请输入图形验证码"></i-input>
          </i-col>
        </Row>
      </FormItem>
      <form-item>
        <a
          href="javascript: void(0)"
          class="submit"
          type="primary"
          @click="handleFindUsername('findUsernameFrom')"
        >找回</a>
      </form-item>
    </Form> -->

    <div class="error" v-show="msg">
      <span
        style="font-family:'Font Awesome 5 Pro Solid', 'Font Awesome 5 Pro', sans-serif;font-weight:900;color:#FF934C;"
        class="fa fa-right"
      ></span>
      {{ msg }}
    </div>
    <div v-if="loginModalType!='register'" class="footer" style="margin-bottom: 10px" v-show="type != '扫码登录'">
      <a @click="type='忘记密码'">忘记密码</a>
      <a @click="type='忘记用户名'">忘记用户名</a>
      <a href="javascript:void()" @click="register">免费注册</a>
    </div>
    <div v-if="loginModalType!='register'" class="other" v-show="type == '密码登录'">
      <span>其它登录方式：</span>
      <svg-icon class="svg" icon-class="wx1"></svg-icon>
      <svg-icon class="svg" icon-class="qq"></svg-icon>
      <svg-icon class="svg" icon-class="wb"></svg-icon>
      <svg-icon class="svg" icon-class="f"></svg-icon>
    </div>
  </div>
</template>
<script>
import { login, getUsernameByPhone } from "@/api";
import { setToken, setUserInfo,getUserInfo } from "@/utils/auth";
import { getQrcodeLoginParam } from "@/api/wechat";
import JGraphicCode from "@/components/common/JGraphicCode";
import Alteration from "./Alteration";
export default {
  components: {
    JGraphicCode,
    Alteration,
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error("手机号格式不正确"));
        }
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        if (value.length < 4 || value.length > 6) {
          // 长度验证
          callback(new Error("验证码格式不正确"));
        }
        callback();
      }
    };
    return {
      type: "扫码登录", // 扫码登录 密码登录 忘记用户名 忘记密码
      msg: "",
      jgraphicCode: "",
      formInline: {
        username: "",
        password: "",
      },
      findUsernameFrom: {
        phone: "",
        graphicCode: "",
      },
      findPswForm: {
        phone: "",
        username: "",
        graphicCode: "",
        smscode: "",
      },
      ruleInline: {
        username: [
          {
            required: true,
            message: "请填写用户名称",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请填写登录密码",
            trigger: "blur",
          },
        ],
      },
      findUsernameRule: {
        phone: [
          {
            validator: validatePhone,
            // required: true,
            // message: "请填写手机号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props:{
    loginModalType:{
      type: String,
      default: ''
    }
  },
  mounted() {
    let THIS = this;
    this.initQrcode();
    window.addEventListener("keydown", (e) => {
      if (e.keyCode == 13) {
        this.handleSubmit("formInline");
      }
    });
    document.addEventListener("changeType", function (e) {
      THIS.type = e.detail.type;
    });
    var event = new CustomEvent('hideLoginBtn');
    document.dispatchEvent(event);
    if(this.loginModalType =='register'){
      this.type = '忘记密码'
    }
  },
  destroyed(){
var event = new CustomEvent('showLoginBtn');
    document.dispatchEvent(event);
  },
  methods: {
    toggleType() {
      if (this.type == "扫码登录") {
        this.type = "密码登录";
      } else if (this.type == "密码登录") {
        this.type = "扫码登录";
      } else {
        this.type = "密码登录";
      }
    },
    handleSubmit(name) {
      let THIS = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          login(THIS.formInline.username, THIS.formInline.password).then(
            (res) => {
              if (res.code === 200) {
                setToken(res.result.token, true);
                setUserInfo(res.result.userInfo);
                THIS.msg = "登录成功！";
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              } else {
                THIS.msg = res.message;
              }
            }
          );
        }
      });
    },
    handleFindUsername(name) {
      let THIS = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.jgraphicCode !== this.findUsernameFrom.graphicCode) {
            this.$Message.info("图形验证码错误");
            return;
          }
          getUsernameByPhone(this.findUsernameFrom.phone).then((res) => {
            if (res.success) {
              THIS.msg = "用户名已发送到您的手机";
            } else {
              THIS.msg = res.message;
            }
          });
        }
      });
    },
    //获取到图形验证码
    generateCode(value) {
      this.jgraphicCode = value.toLowerCase();
    },
    register() {
      this.$emit("closemodal", "");
      this.$router.push("/register");
    },
    initQrcode() {
      getQrcodeLoginParam(window.location.pathname).then((res) => {
        if (res.success) {
          var qrcodeParam = res.result;
          console.log("初始化js");
          const s = document.createElement("script");
          s.type = "text/javascript";
          s.src =
            "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
          const wxElement = document.body.appendChild(s);
          console.log("初始化js");
          wxElement.onload = function () {
            new window.WxLogin({
              id: "qrcode",
              appid: qrcodeParam.appId,
              scope: "snsapi_login",
              redirect_uri: qrcodeParam.redirectUrl,
              state: qrcodeParam.state,
              style: "black",
              href:
                "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30uaW5mbywudGl0bGUsLnN0YXR1c19pY29uIHtkaXNwbGF5OiBub25lO30uaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fQ==",
            });
          };
        }
      });
    },
  },
};
</script>
<style lang="scss">
.login {
  .login-form {
    .ivu-input {
      height: 45px;
      // border-left: 0;
      // &:focus {
      //   border: none;
      // }
    }
  }
}
</style>
<style lang="scss" scoped>
.login {
  height: 360px;
  .login-header {
    font-size: 14px;
    .change {
      text-align: right;
      font-size: 12px;

      span {
        border: 1px solid #00c1de;
        padding: 2px 8px;
        color: #00c1de;
        position: relative;
        background-color: #e6f9fc;
        border: #00c1de solid 1px;
        border-radius: 3px;
        &:after {
          box-sizing: content-box;
          width: 0px;
          height: 0px;
          position: absolute;
          top: 0px;
          right: -18px;
          padding: 0;
          border: 9px solid transparent;
          border-left-color: #00c1de;
          display: block;
          content: "";
          z-index: 10;
        }
        &:before {
          box-sizing: content-box;
          width: 0px;
          height: 0px;
          position: absolute;
          top: 0;
          right: -17px;
          padding: 0;
          border: 9px solid transparent;
          border-left-color: #e6f9fc;
          display: block;
          content: "";
          z-index: 12;
        }
      }
      .border {
        margin-left: 20px;
        width: 23px;
        height: 13px;
        display: inline-block;
        border-top: 1px solid #ccc;
        border-right: 1px solid #ccc;
      }
    }
  }
  .tip {
    text-align: center;
    margin: 0px auto;
    #qrcode {
      height: 260px;
      padding-top: 20px;
      img {
        width: 200px;
        height: 200px;
      }
    }
    img {
      display: block;
      width: 150px;
      margin: 0 auto;
    }
    .svg {
      vertical-align: middle;
      font-size: 44px;
      margin-right: 10px;
    }
    span {
      font-size: 12px;
    }
  }
  .error {
    background: rgb(254, 252, 238);
    color: #333;
    border: 1px solid #ff934c;
    font-size: 12px;
    padding: 3px 10px;
    margin: 6px 20px;
  }
  .footer {
    text-align: right;
    a {
      margin-right: 10px;
      color: #999 !important;
      font-size: 12px;
      &:hover {
        color: #666;
      }
    }
  }
  .login-form {
    margin-top: 20px;
    padding: 20px 20px 0 20px;
    .submit {
      height: 45px;
      line-height: 45px;
      background: rgba(0, 193, 222, 1);
      width: 100%;
      display: block;
      color: #fff;
      text-align: center;
    }
  }
  .other {
    .svg {
      background: #ccc;
      border-radius: 50%;
      padding: 3px;
      font-size: 26px;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/login.vue